var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h1',[_vm._v("Skills - "+_vm._s(_vm.user.email))])])
}
var staticRenderFns = []

export { render, staticRenderFns }